import React from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

function Login() {
  return (
    <div className="under-dev-page">
      <div className="under-dev-icon">🚧</div>
      <h1 className="under-dev-title">Under Development</h1>
      <p className="under-dev-sub">The account section is currently being built.<br />Check back soon!</p>
      <Link to="/" className="under-dev-btn">Back to Home</Link>
    </div>
  );
}

export default Login;
